var map = {
	"./allow_bottom.svg": "V9fb",
	"./allow_top.svg": "c5Jm",
	"./browse.svg": "sLR2",
	"./collect.svg": "b1Qu",
	"./comment.svg": "ip89",
	"./edit_fill.svg": "MqNj",
	"./home.svg": "0Dh3",
	"./like.svg": "VkQC",
	"./location.svg": "6GRT",
	"./mobile_menu.svg": "MQVg",
	"./mobile_menu_left.svg": "0Ndt",
	"./share.svg": "2t8y",
	"./shopCarIcon.svg": "mIxe",
	"./uav.svg": "XY06",
	"./userIcon.svg": "npUQ",
	"./vector.svg": "wAwC",
	"./yx_icon_company.svg": "L5gW",
	"./yx_icon_down.svg": "Juze",
	"./yx_icon_left.svg": "ID2O",
	"./yx_icon_phone.svg": "TnUL",
	"./yx_icon_right.svg": "WamD",
	"./yx_icon_search.svg": "ZMSk",
	"./yx_icon_two_down.svg": "XFge",
	"./yx_icon_two_up.svg": "ATXx",
	"./yx_icon_up.svg": "pj+x",
	"./yx_icon_user.svg": "/UlP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IeHe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgIcons/svg nonrecursive \.svg$
// module id = IeHe
// module chunks = 76